
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

import AnalyticsIcon from "../../../svg/Analytics";
import SettingsIcon from "../../../svg/Setting";
import ChevronDownIcon from "../../../svg/Arrow";
import ChevronUpIcon from "../../../svg/Arrow";
import Menu from "../../../svg/Menu";
import Meal from "../../../svg/Meal";
import Register from "../../../svg/Register";
import Scanner from "../../../svg/Scanner";

const Sidebar = ({ expanded, isOpen, setIsOpen }) => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsHover, setSettingsHover] = useState(false);
  const hoverTimerRef = useRef(null);

  const handleMouseEnter = () => {
    if (expanded) return;
    hoverTimerRef.current = setTimeout(() => {
      setSettingsHover(true);
    }, 250);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimerRef.current);
    setSettingsHover(false);
  };

  const handleLinkClick = () => {
    if (window.innerWidth < 768) {
      setIsOpen(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className={`
          fixed md:static top-0 left-0 h-screen bg-white z-50
          transition-all duration-300 text-darkGray 

          ${expanded ? "w-64" : "w-20"}
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        <div className="flex flex-col p-3 gap-2">
          <Link to="/analytics" onClick={handleLinkClick}>
            <SidebarItem
              icon={<AnalyticsIcon />}
              label="Analytics"
              expanded={expanded}
            />
          </Link>

          <Link to="/rfid-registration" onClick={handleLinkClick}>
            <SidebarItem
              icon={<Register />}
              label="Registration"
              expanded={expanded}
            />
          </Link>

          <Link to="/card-scanner" onClick={handleLinkClick}>
            <SidebarItem
              icon={<Scanner />}
              label="Card Scanner"
              expanded={expanded}
            />
          </Link>

          <div
            className="relative"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
              onClick={() => expanded && setSettingsOpen((p) => !p)}
            >
              <SettingsIcon />
              {expanded && (
                <>
                  <span>Settings</span>
                  {settingsOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </>
              )}
            </div>

            {expanded && settingsOpen && (
              <div className="mt-2 ml-2">
                <SettingsMenu />
              </div>
            )}

            {!expanded && (
              <div
                className={`absolute left-full top-0 ml-3 z-50 transition-all duration-200
                  ${
                    settingsHover
                      ? "opacity-100 translate-x-0"
                      : "opacity-0 translate-x-2 pointer-events-none"
                  }`}
              >
                <SettingsMenu floating />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const SidebarItem = ({ icon, label, expanded }) => (
  <div className="relative group flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 cursor-pointer">
    {icon}
    {expanded && <span>{label}</span>}

    {!expanded && (
      <span className="absolute left-full top-1/2 -translate-y-1/2 ml-2 bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100">
        {label}
      </span>
    )}
  </div>
);

const SettingsMenu = ({ floating = false }) => (
  <div
    className={`flex flex-col gap-3 text-sm rounded-xl p-4 w-56
      ${floating ? "bg-white shadow-xl border" : "bg-gray-50 border"}`}
  >
    <SettingsLink to="/setting/menu" icon={<Menu />} label="Menu" />
    <SettingsLink to="/setting/meals" icon={<Meal />} label="Meal" />
  </div>
);

const SettingsLink = ({ to, icon, label,onClick }) => (
  <Link to={to} onClick={onClick}>
    <div className="flex items-center gap-4 hover:text-blue-600 cursor-pointer">
      {icon}
      <span>{label}</span>
    </div>
  </Link>
);

export default Sidebar;
